import { Injectable } from '@angular/core';
import { EncryptDecrypt } from './encrypt-decrypt';

@Injectable({
  providedIn: 'root',
})
export class WebStorage {
  constructor(private encryDecryService: EncryptDecrypt) {}
  setKey(key: string) {
    let modifiedkey = this.encryDecryService.setKey(key);
    window.localStorage.setItem(
      '_temp',
      this.encryDecryService.encode(modifiedkey)
    );
  }
  storeInLocal(key: string, value: any) {
    if (!key) return;
    window.localStorage.setItem(
      key,
      this.encryDecryService.encrypt(JSON.stringify(value))
    );
  }
  fetchFromLocal(key: string) {
    if (!key) return null;
    return this.encryDecryService.decrypt(window.localStorage.getItem(key)!);
  }
  storeItem(key: string, value: any) {
    if (!key) return;
    let encryptedValue = this.encryDecryService.encrypt(JSON.stringify(value));
    // value is encrypted before storing it in sessionStorage
    sessionStorage.setItem(key, encryptedValue);
  }
  retrieveItem(key: string) {
    if (!key) return null;
    // value is decrypted after retrieving it from sessionStorage
    return this.encryDecryService.decrypt(sessionStorage.getItem(key)!);
  }
}
